<template>

    <div class="content-section w-full">

        <h1 class="text-5xl font-semibold">Torbay design library</h1>

        <p class="mt-8">
            Welcome to the torbay design library....
        </p>

        <div class="mt-8 border border-gray-400 bg-white rounded-sm w-1/3">
            <router-link to="/ui" class="block flex-col space-y-8 px-8 py-8 hover:bg-blue-100">
                <div class="w-8 h-8 bg-torbay-primary-blue"></div>
                <div class="mt-8 font-semibold">UI components</div>
                <p class="mt-4">
                    Example of the components available in the Torbay design library
                </p>
            </router-link>
        </div>

    </div>

</template>

<script>
    export default {
        //name: "Home",
        //title: "Home",
        //description: "The home page"
    };
</script>